<template>
  <div class="tax-section">
    <h6 class="section-label mt-0">
      <feather-icon icon="PercentIcon" size="13" class="mr-50" />Commission
    </h6>

    <b-form-group class="mb-1">
      <label class="d-block">Calculation Method</label>
      <b-form-radio-group
        v-model="commissionTypeModel"
        :options="[
          { text: '% of Selling Price', value: 'percentage' },
          { text: 'Manual Amount', value: 'manual' },
        ]"
      />
    </b-form-group>

    <b-row>
      <b-col md="6" v-if="commissionType === 'percentage'">
        <b-form-group class="mb-0">
          <label>Commission Rate</label>
          <b-input-group append="%">
            <b-form-input
              :value="formatNumber(commissionRate)"
              @input="v => $emit('update:commissionRate', parseNumber(v))"
              type="text"
              placeholder="e.g. 3"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="6" v-else>
        <b-form-group class="mb-0">
          <label>Commission Amount <span class="text-muted font-weight-normal">(before VAT)</span></label>
          <b-input-group prepend="฿">
            <b-form-input
              :value="formatNumber(commissionManualAmount)"
              @input="v => $emit('update:commissionManualAmount', parseNumber(v))"
              type="text"
              placeholder="e.g. 150,000"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-checkbox v-model="commissionIncludeVatModel" class="mt-1">
      Include VAT (7%)
    </b-form-checkbox>
    <b-form-checkbox v-model="showCommissionInPdfModel" class="mt-50">
      Show Commission &amp; VAT in PDF
    </b-form-checkbox>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BInputGroup, BFormRadioGroup, BFormCheckbox,
} from 'bootstrap-vue'
import { formatNumber, parseNumber } from '../format'

export default {
  components: {
    BRow, BCol, BFormGroup, BFormInput, BInputGroup, BFormRadioGroup, BFormCheckbox,
  },
  props: {
    commissionType: { type: String, required: true },
    commissionRate: { type: Number, default: null },
    commissionManualAmount: { type: Number, default: null },
    commissionIncludeVat: { type: Boolean, default: true },
    showCommissionInPdf: { type: Boolean, default: true },
  },
  computed: {
    commissionTypeModel: {
      get() { return this.commissionType },
      set(value) { this.$emit('update:commissionType', value) },
    },
    commissionIncludeVatModel: {
      get() { return this.commissionIncludeVat },
      set(value) { this.$emit('update:commissionIncludeVat', value) },
    },
    showCommissionInPdfModel: {
      get() { return this.showCommissionInPdf },
      set(value) { this.$emit('update:showCommissionInPdf', value) },
    },
  },
  methods: {
    formatNumber,
    parseNumber,
  },
}
</script>
